import _ from "lodash";

export const REQUIRED_FIELDS = {
    1: [],
    2: [
        "Business_Name",
        "Doing_Business_As",
        "address.buildingNumber",
        "address.street",
        "address.city",
        "address.state",
        "address.pinCode",
        "address.country",
        "Business_Registration_Country",
        "entityType",
        "Business_Registration_Number",
        "Business_Formation_Date",
        "Business_Industry_Type",
        "empCount",
        "BUS_Source_Of_Funds",
        "liquidFunds",
        "hasEntity",
    ],
    3: ["Primary_Business_Activities", "Business_Product_Services", "Customer_Description", "Business_Plan_Disclosure", "Illegal_Immoral_Disclosure", "Deposit_Reasons", "Payment_Reasons", "Deposit_Locations", "Payment_Locations"],
    4: ["primaryBusinessModel", "Regulatory_Agency", "talkToSales"],
    5: [],
    6: ["hearAbtUs", "showName", "refName"],
    7: ["firstName", "lastName", "Date_Of_Birth"],
}

export const compareAddresses = (a = {}, b = {}) => {
    const keys = ['buildingNumber', 'street', 'pinCode', 'city', 'state', 'country'];
    const aPicked = _.pick(a, keys);
    const bPicked = _.pick(b, keys);

    // If either address is missing all of those keys, return false
    if (Object.keys(aPicked).length === 0 || Object.keys(bPicked).length === 0) {
        return false;
    }

    // Otherwise, compare the picked fields
    return _.isEqual(aPicked, bPicked);
};

export const BUSINESS_PLUS_COMPARISON_DATA = [
    {
        title: "USD Depository Account",
        bPlus: { isValid: true, description: "" },
        bPrime: { isValid: true, description: "" },
    },
    {
        title: "Domestic and International USD Deposits & Payments",
        bPlus: { isValid: true, description: "" },
        bPrime: { isValid: true, description: "" },
    },
    {
        title: "Foreign Currency Payments",
        bPlus: { isValid: true, description: "" },
        bPrime: { isValid: true, description: "" },
    },
    {
        title: "Direct Stablecoin Deposits & Payments",
        bPlus: { isValid: true, description: "" },
        bPrime: { isValid: true, description: "" },
    },
    {
        title: "Visa Corporate Debit Card",
        bPlus: { isValid: true, description: "" },
        bPrime: { isValid: true, description: "" },
    },
    {
        title: "Order Cards for Operators",
        bPlus: { isValid: true, description: "" },
        bPrime: { isValid: true, description: "" },
    },
    {
        title: "Digital Asset Custody Accounts",
        bPlus: { isValid: true, description: "" },
        bPrime: { isValid: true, description: "" },
    },
    {
        title: "Digital Assets - USD Conversion",
        bPlus: { isValid: true, description: "" },
        bPrime: { isValid: true, description: "" },
    },
    {
        title: "Money Market Account (Upon request & approval)",
        bPlus: { isValid: true, description: "" },
        bPrime: { isValid: true, description: "" },
    },
    {
        title: "API Access (Upon request & approval)",
        bPlus: { isValid: false, description: "" },
        bPrime: { isValid: true, description: "(Additional fees apply)" },
    },
    {
        title: "Virtual Account Numbers (Upon request & approval)",
        bPlus: { isValid: false, description: "" },
        bPrime: { isValid: true, description: "(Additional fees apply)" },
    },
    {
        title: "Onboarding Time",
        bPlus: { isValid: null, description: "1 Week" },
        bPrime: { isValid: null, description: "2 - 4 Weeks" },
    },
]